import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as BoardAction from '../../../../library/board/BoardAction';

class EventWinnerViewer extends Component {
  componentDidMount() {
    let pageNo = 1,
      pageSize = 1;
    this.props.getChildPostList(pageNo, pageSize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.postId !== this.props.postId) {
      let pageNo = 1,
        pageSize = 1;
      this.props.getChildPostList(pageNo, pageSize);
    }
  }

  render() {
    let { childPostList } = this.props;
    return (
      <div className="layer-wrap small">
        <h2>당첨여부 확인</h2>
        <div className="event-check-text">
          {childPostList &&
            childPostList.results[0] &&
            childPostList.results[0].html &&
            childPostList.results[0].html !== '' && (
              <r_
                dangerouslySetInnerHTML={{
                  __html: childPostList.results[0].html,
                }}
              ></r_>
            )}
          <button className="close" onClick={this.props.onClose}>
            팝업 닫기
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    childPostList: state.BoardReducer.childPostList,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { boardType, boardName, postId } = ownProps;
  return {
    getChildPostList: (childPageNo, childPageSize) => {
      dispatch(
        BoardAction.getChildPostList(
          boardType,
          boardName,
          postId,
          childPageNo,
          childPageSize
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventWinnerViewer);
